/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_Link_CareersInputs */

const en_home_footer_link_careers = /** @type {(inputs: Home_Footer_Link_CareersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Careers`)
};

const fr_home_footer_link_careers = /** @type {(inputs: Home_Footer_Link_CareersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrières`)
};

/**
* | output |
* | --- |
* | "Careers" |
*
* @param {Home_Footer_Link_CareersInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_link_careers = /** @type {((inputs?: Home_Footer_Link_CareersInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Link_CareersInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_link_careers(inputs)
	return fr_home_footer_link_careers(inputs)
});